import React from 'react';
import { Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-wrapper">
        <div className="top-bar-left">
          <a href="tel:0404844257" className="top-bar-link">
            <Phone size={16} />
            <span>0404 844 257</span>
          </a>
          <a href="mailto:info@energyspectrum.com.au" className="top-bar-link">
            <Mail size={16} />
            <span>info@energyspectrum.com.au</span>
          </a>
        </div>
        <div className="top-bar-right">
          <span className="top-bar-text">Follow Us:</span>
          <div className="top-bar-social">
            <a href="https://www.facebook.com/profile.php?id=61582804771105" className="top-bar-social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
              <Facebook size={18} />
            </a>
            <a href="https://www.instagram.com/energy.spectrum/" className="top-bar-social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <Instagram size={18} />
            </a>
            <a href="https://www.linkedin.com/company/109582365" className="top-bar-social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
              <Linkedin size={18} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;